import './headerTable.sass'

/**
 * Componente de encabezado para tablas de posiciones deportivas
 * Muestra un título destacado como encabezado visual principal
 * Proporciona estructura semántica y accesibilidad para la sección
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.title - Título a mostrar en el encabezado
 * 
 * @returns {JSX.Element} Encabezado con título estilizado
 */
export default function HeaderTable({ title }) {

  return (
    <header 
      className="positions-table__header-head" 
      role="banner"
      aria-label={`Sección de ${title}`}
    >
      <h2 className="header-title">
        {title}
      </h2>
    </header>
  );
}